import React, {
	useCallback, useState, useEffect
} from "react"
import {
	Modal, Form, Input, Switch
} from "antd"
import {
	useDispatch, useSelector
} from "react-redux"
import {
	appealsActions
} from "../../store/actions"
import i18n from "../../localization"
import i18nGlobal from "../../../../localization"
import "antd/lib/modal/style/index.css"
import ModalTemplateMessages from "../../../MessageTemplates/ModalTemplateMessages"
import CustomButton from "../../../../components/ButtonCustom"
import './style.css'
import Notifications from "../../../../helpers/Notifications"
import sign from "../../../../helpers/sign"
import UploadFile from "../../../UploadFile"
import {
	default as uploadFileLocale
} from '../../../UploadFile/localization'
import notice from "../../../../components/Notice"
import { useMemo } from "react"

const { TextArea } = Input
const LeaveWithoutConsideration = ({ id, disabled, underControl = false }) => {
	const [form] = Form.useForm()
	const dispatch = useDispatch()

	const isRu = useSelector((state) => state.globalReducer.isRu)
	const { idWCAppeal, reOrgAppeal, WCResult, error } = useSelector((state) => state.appealsReducer)
	const { systemEnvironment } = useSelector((state) => state.userReducer)

	const [loading, setLoading] = useState(false)
	const [visible, setV] = useState(false)
	const [visibleTemplate, setVisibleTemplate] = useState(false)
	const [reportFiles, setReportFiles] = useState([])
	const [reportFileSignatures, setReportFileSignatures] = useState([])
	const [files, setFiles] = useState([])
	const [fileSignatures, setFileSignatures] = useState([])
	const {messages} = useSelector((state) => state.appealsControlReducer);
	const maxCountOfAdditionalFiles = 1 

	const reader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)

		return fileReader
	}, [])

	const reportReader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)

		return fileReader
	}, [])

	reader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setFileSignatures([...fileSignatures, result.res.data.cms])
			}
			else if (result.error)
				setFileSignatures([])
		})
	}

	reportReader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setReportFileSignatures([...reportFileSignatures, result.res.data.cms])
			}
			else if (result.error)
				setReportFileSignatures([])
		})
	}


	const withoutConsiderationAppeal = useCallback((params) => {
		dispatch(appealsActions.withoutConsiderationAppeal(params))
	}, [dispatch])

	const submitValues = async () => {
		const fd = new FormData()
		fd.append('id', id)
		const values = form.getFieldsValue()
		for (const key in values) {
			if (Object.hasOwnProperty.call(values, key)) {
				if (key !== 'files' && key !== 'reportFiles')
					fd.append(key, values[key])
			}
		}
		if (systemEnvironment.ecpEnabled) {
			sign(window.btoa(unescape(encodeURIComponent(values.reason))), false, systemEnvironment.cp_address_n).then(result => {
				if (result.res) {
					fd.append("signature", result.res.data.cms)
					if(values.reportText?.trim()){
						sign(window.btoa(unescape(encodeURIComponent(values.reportText))), false, systemEnvironment.cp_address_n).then(result => {
							if (result.res) {
								fd.append("reportSignature", result.res.data.cms)
								setFilesAndSignaturesInFormData(fd)
							}
							else
								setLoading(false)
						})
					} else {
						setFilesAndSignaturesInFormData(fd)
					} 
				}
				else
						setLoading(false)
			})
		} else {
			setFilesAndSignaturesInFormData(fd)
		}
		
	}

	const setFilesAndSignaturesInFormData = (fd) => {
		const filesToUpload = getUnloadedFilesFromList(files)
		const reportFilesToUpload = getUnloadedFilesFromList(reportFiles)
		if (filesToUpload.length)
			filesToUpload.forEach(file => {
				fd.append('Files', file.originFileObj)
			})
		if (fileSignatures.length)
			fileSignatures.forEach(sign => {
				fd.append('FileSignatures', sign)
			})
		if (reportFilesToUpload.length)
			reportFilesToUpload.forEach(file => {
				fd.append('ReportFiles', file.originFileObj)
			})
		if (reportFileSignatures.length)
			reportFileSignatures.forEach(sign => {
				fd.append('ReportFileSignatures', sign)
			})

		withoutConsiderationAppeal(fd)
		setLoading(false)

	}

	const getUnloadedFilesFromList = (fileList) => fileList?.filter(file => !file.id)

	useEffect(() => {
		if (WCResult && visible) {
			setV(false)
			Notifications.successNotice(
				reOrgAppeal?.controlReOrgs?.length || underControl == true 
				? (messages?.length > 0 
				   ? i18n.reportForControlOrgSuccessCreate[isRu] 
				   : i18n.appealGetStatusOnControl[isRu]) 
				: i18n.successChangeAppealStatus[isRu], '', 15)
		}
	}, [WCResult])

	useEffect(() => {
		if (error && visible) {
			setFileSignatures([])
			setReportFileSignatures([])
		}
	}, [error])

	useEffect(() => {
		const filesToUpload = getUnloadedFilesFromList(reportFiles)
		if (filesToUpload.length && reportFileSignatures.length > 0 && reportFileSignatures.length == filesToUpload?.length) {
			submitValues()
		} else if (filesToUpload.length && reportFileSignatures.length > 0 && reportFileSignatures.length < filesToUpload?.length) {
			reportReader.readAsDataURL(filesToUpload[reportFileSignatures.length].originFileObj)
		}
	}, [reportFileSignatures])

	useEffect(() => {
		const filesToUpload = getUnloadedFilesFromList(files)
		if (filesToUpload.length && fileSignatures.length > 0 && fileSignatures.length == filesToUpload?.length) {
			const reportFilesToUpload = getUnloadedFilesFromList(reportFiles)
			if (reportFilesToUpload?.length > 0 && systemEnvironment.ecpEnabled){
				reportReader.readAsDataURL(reportFilesToUpload[0].originFileObj)
			} else {
				submitValues()
			}
		} else if (filesToUpload.length && fileSignatures.length > 0 && fileSignatures.length < filesToUpload?.length) {
			reader.readAsDataURL(filesToUpload[fileSignatures.length].originFileObj)
		}
	}, [fileSignatures])

	const showModal = () => {
		setV(true)
	}

	const handleCancel = (e) => {
		form.setFieldsValue({
			reason : null,
			reportText : null,
			files : null,
			reportFiles : null,
			isCorrespondenceTerminated : false,
		})
		setFiles([])
		setFileSignatures([])
		setReportFiles([])
		setReportFileSignatures([])
		setLoading(false)
		setV(false)
	}

	const onFinish = () => {
		try {
			const filesToUpload = getUnloadedFilesFromList(files)
			const reportFilesToUpload = getUnloadedFilesFromList(reportFiles)
			setLoading(true)
			if (!systemEnvironment.ecpEnabled) {
				submitValues()
				setLoading(false)
			}
			else {
				if (filesToUpload.length)
					reader.readAsDataURL(filesToUpload[0].originFileObj)
				else if (reportFilesToUpload.length)
					reportReader.readAsDataURL(reportFilesToUpload[0].originFileObj)
				else
					submitValues()
			}
		} catch (e) {
			notice('error', 'Не удалось оставить обращение без рассмотрения.', e.message, 5)
		}
	}

	const getText = (text) => {
		form.setFieldsValue({
			reason: text
		})
		setVisibleTemplate(false)
	}

	const handleChangeReportFiles = (val) => {
		if (val.fileList.length < 6) {
			setReportFiles(val.fileList)
			setReportFileSignatures([])
		}
		else
			Notifications.errorNotice(uploadFileLocale.maxCountFiles[isRu])
	}

	const handleRemoveReportFiles = (id) => {
		const newList = reportFiles.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setReportFiles(newList)
		setReportFileSignatures([])
	}

	const handleChangeFiles = (val) => {
		if (val.fileList.length <= 1) {
			setFiles(val.fileList)
			setFileSignatures([])
		}
		else
			Notifications.errorNotice(uploadFileLocale.maxCountOfAdditionalFiles[isRu].format(maxCountOfAdditionalFiles))
	}

	const handleRemoveFiles = () => {
		const newList = files.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setFiles(newList)
		setFileSignatures([])
	}

	return (
		<>
			<CustomButton
				disabled={disabled}
				type="grey"
				onClick={showModal}
			>
				{i18n.leaveWithoutConsiderationAppeal[isRu]}
			</CustomButton>
			<Modal
				destroyOnClose
				footer={null}
				title={i18n.leaveWithoutConsiderationAppeal[isRu]}
				visible={visible}
				width={840}
				onCancel={handleCancel}
			>
				<Form
					form={form}
					layout="horizontal"
					name="reasonForm"
				>
					<ModalTemplateMessages
						getText={getText}
						isRu={isRu}
						setVisibleTemplate={setVisibleTemplate}
						visibleTemplate={visibleTemplate}
					/>
					<Form.Item
						label={
							(<div className="label-reason-form">
								<span>
									{i18n.leaveWithoutConsiderationHeader[isRu]}
								</span>
								<CustomButton
									type="grey"
									onClick={() => setVisibleTemplate(true)}
								>
									{i18n.chooseTemplate[isRu]}
								</CustomButton>
							</div>)
						}
						labelAlign="left"
						name="reason"
						rules={[
							{
								required: true,
								whitespace: true,
								message: i18n.leaveWithoutConsiderationRequierd[isRu]
							}
						]}
					>
						<TextArea
							autoSize={{
								minRows: 3,
								maxRows: 8
							}}
							maxLength={5000}
							placeholder={i18n.leaveWithoutConsiderationPlaceholder[isRu]}
						/>
					</Form.Item>
					<Form.Item
							name="isCorrespondenceTerminated"
							initialValue={false}
							label={i18n.IsCorrespondenceTerminated[isRu] }
							valuePropName="checked"
							className="isCorrespondenceTerminated"
						>
							<Switch
								checkedChildren={i18nGlobal.yes[isRu]}
								unCheckedChildren={i18nGlobal.no[isRu]}
							/>
					</Form.Item>
					<Form.Item
						name="files"
						label={<div className="label-reason-form-upload">
							{i18n.attachFiles[isRu]}
						</div>
						}
					>
						<UploadFile
							fileList={files}
							listType="text"
							removeFiles={handleRemoveFiles}
							onChangeCustom={handleChangeFiles}
							/>
					</Form.Item>
					{reOrgAppeal?.controlReOrgs?.length || underControl == true ? <>
						<div className="form__divider"></div>
						<Form.Item
							name="reportText"
							label={i18n.reportForOrganization[isRu]}
							labelCol={{span: 24}}
							rules={[
								{
									required: true,
									whitespace: true,
									message: i18n.reportTextForOrganizationMessage[isRu]
								}
							]}
						>
							<TextArea
								autoSize={{
									minRows: 3,
									maxRows: 8
								}}
								maxLength={5000}
							/>
						</Form.Item>
						<Form.Item
							name="reportFiles"
							label={<div className="label-reason-form-upload">
								{i18n.filesForOrganization[isRu]}
							</div>
							}
						>
							<UploadFile
								fileList={reportFiles}
								listType="text"
								onChangeCustom={handleChangeReportFiles}
								removeFiles={handleRemoveReportFiles}
							/>
						</Form.Item>
					</>
						: null}
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end'
						}}
					>
						<CustomButton
							disabled={Boolean(idWCAppeal)}
							htmlType="submit"
							loading={loading}
							className="submitLeaveWithoutConsideration"
							type="orange"
							onClick={() => form.validateFields().then(values => onFinish(values))}
						>
							{i18nGlobal.confirm[isRu]}
						</CustomButton>
					</div>
				</Form>
			</Modal>
		</>
	)
}
export default LeaveWithoutConsideration
